import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,message    } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';





const buttonWidth = 70;
const { TextArea } = Input;
function callback(key) {
  console.log(key);
}


function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function getBase64_(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			loading: false,
			name: '',
			mobile: '',
			licence: '',
			loading: false,
  		    iconLoading: false,
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'],id : this.props.match.params.id});
		
		}
		this.checkData()
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			let id = this.props.match.params.id;
			var app = {user_id : user_id,id:id,school_id:school_id}
			getData('Transport/route_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							name: result['data'][0]['name'],
							details: result['data'][0]['details'],
						});
						
						
						
						
						
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
	}
  }
  
	
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			name : this.state.name,
			details : this.state.details,
			id : this.props.match.params.id
		}
		
		getData('Transport/edit_route',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.error_msg,2);
									
					
				document.getElementsByName(result.error_name)[0].classList.add("error_focus");
										
				
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Route Updated',2);
				this.setState({ loading: false });
				this.setState({comment_text:''});
				window.location.href = '/transport-setup/manage-route/route';
			}
			else{
				this.setState({ loading: false });
			}
		});
	  }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

	}
	
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
	if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
  };
  
  
  
  handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

		this.setState({
		  previewImage: file.url || file.preview,
		  previewVisible: true,
		  previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
		});
	};
	
	handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        }),
      );
    }
  };
  
  handledelete=(e)=>{
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			id : e,
		}
		
		getData('Transport/route_delete',app).then((result) => {
			if(result.status==200){
				message.config({ top: 150});
				message.success('Deleted Successfull',2);
				window.location.href = '/transport-setup/manage-route/route';
				
			}
		});
	 

	}	

  handleChange = ({ fileList }) => this.setState({ fileList });

	render()

	{
	
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <div className="ant-upload-text">Upload</div>
      </div>
    );
	const uploadButton1 = (
		  <div>
			{this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div className="ant-upload-text">Upload Profile</div>
		  </div>
		);
		const { imageUrl } = this.state;
					
		return (
			<div class="mobile_view">
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Edit Route
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/manage-route/route`} class="router-link-active" target="_self">Manage Route</a></li>
										<li class="breadcrumb-item"> Edit Route </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			<div id="main" class="bg-off">
         <div class="row">
		  <div class="col s12 m12 ex-padd">   
            <div class="">
			   <div class="col-md-12 mb-20 mt-10 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 flow-root">
                     
						
						  
						  <div class="col-md-12 no-padd">
								<div class="col-md-6 mb-10">
									<label>Route Name *</label>
									<input type="text" name="name" defaultValue={this.state.name} onChange={this.handleSizeChange}  />
								</div>	
								
						  </div>
						  <div class="col-md-12 pl-0">
								
								<div class="col-md-6 mb-10">
									<label>Details</label>
									<TextArea rows={4} name="details" value={this.state.details} onChange={this.handleSizeChange} />
								</div>	
						  </div>
						 
						
						
						
					</div> 
					
										
					
					
					<div class="col-md-6 meal mt-20 mb-20 pt-20 bt center">
						 <Button className="ant-btn btn  btn-primary mr-2" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
